import React, { ReactNode } from "react";
import { Link } from "react-router-dom";

const buttonStyles = {
  default:
    "border-transparent text-white bg-spectum-dark hover:bg-spectum-light",
  danger: "border border-red-600 bg-red-300 hover:bg-red-200",
  disabled: "opacity-50 cursor-not-allowed",
  success: "border-transparent text-white bg-green-800 hover:bg-green-600",
  cancel: "border text-black bg-white hover:bg-gray-100",
  add: "text-gray-700 border-gray-700 bg-white",
};

interface ButtonProps {
  children: ReactNode;
  id?: string;
  onClick?: (e: any) => void;
  type?: "button" | "submit" | "reset";
  variant?: keyof typeof buttonStyles;
  size?: "md" | "sm";
  disabled?: boolean;
  link?: boolean;
  to?: string;
  ref?: React.Ref<HTMLButtonElement | HTMLAnchorElement>;
  btnClasses?: string;
}

const sizeStyles = {
  md: "px-4 h-9 text-xs",
  sm: "px-2.5 h-7 text-xxs",
};

const linkSizeStyles = {
  md: "px-4 h-9 text-xs",
  sm: "px-2.5 h-7 text-xxs",
};

const Button: React.FC<ButtonProps> = ({
  children,
  id,
  onClick,
  type = "button",
  variant = "default",
  size = "md",
  disabled = false,
  link = false,
  to = "",
  ref,
  btnClasses,
}) => {
  const baseStyles = `${sizeStyles[size]} flex justify-center items-center gap-2 shadow rounded focus:outline-none uppercase`;

  return link ? (
    <Link
      to={to}
      className={`${linkSizeStyles[size]} flex border gap-2 items-center justify-center rounded text-black bg-white uppercase text-center hover:bg-gray-100 shadow`}
      ref={ref as React.Ref<HTMLAnchorElement>}
    >
      {children}
    </Link>
  ) : (
    <button
      id={id}
      ref={ref as React.Ref<HTMLButtonElement>}
      disabled={disabled}
      type={type}
      onClick={onClick}
      className={`${baseStyles} ${buttonStyles[variant]} ${btnClasses} ${disabled ? buttonStyles.disabled : ""}`}
    >
      {children}
    </button>
  );
};

export default Button;
